import styled from "styled-components";

export const InfoPagesWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  text-align: start;
  margin: 0 auto;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: .7rem 0;
    padding: 0;
  }
  p {
    padding: 0;
    margin: .8rem 0;
    line-height: 1.8;
  }

  h1 {
    font-size: 2.9rem;
  }
  h2 {
    font-size: 2.6rem;
  }
  h3 {
    font-size: 2.3rem;
  }
  h4 {
    font-size: 2.1rem;
  }
  h5 {
    font-size: 1.8rem;
  }
  h6 {
    font-size: 1.5rem;
  }

  a {
    color: grey;
    text-decoration: underline;
  }
  width: 700px;
  max-width: 90%;
`;
